import React from 'react';
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
// import HeaderOne from "../../common/header/HeaderOne";
// import FooterOne from "../../common/footer/FooterOne";
import BreadcrumbOne from "../breadcrumb/BreadcrumbOne";
import SectionTitle from "../sectionTitle/SectionTitle";
import ServiceOne from "./ServiceOne";
// import ServiceTwo from "./ServiceTwo";
// import ServiceThree from "./ServiceThree";
// import ServiceFour from "./ServiceFour";
// import ServiceFive from "./ServiceFive";
import Separator from "../separator/Separator";

const Service = () => {
    return (
        <>

            <SEO title="Service || Doob - React Business  Template" />
            <Layout>
                <BreadcrumbOne
                    title="Get Your Business To <br /> The Next Level."
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Service"
                />
                <div className="main-content">

                   

                    
                    <Separator />

                    {/* Start Service Area  */}
                    <div className="rn-service-area rn-section-gap ">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "We are great at what we do."
                                        title = "Our Services."
                                        description = "Our experts will guide you through your entire IT transformation,<br /> from strategy and consulting to managed services."
                                     />
                                </div>
                            </div>
                            <ServiceOne 
                                serviceStyle = "service__style--1 bg-color-blackest radius mt--25 rbt-border"
                                textAlign = "text-left"
                             />
                        </div>
                    </div>
                    {/* End Service Area  */}

                    <Separator />

                    

                    
                </div>

            </Layout>
            
        </>
    )
}

export default Service;
